export const translations = {
  en: {
    // Header / Nav
    nav_features: "Features",
    nav_story: "Story",
    nav_beta: "Beta",
    header_cta: "Join the Beta",

    // Hero
    hero_badge: "Kidney health companion",
    hero_headline: "Your dialysis journey, easier to understand.",
    hero_sub: "Nephrix helps people living with dialysis track treatments, fluids, laboratory results and daily health information — all in one place.",
    hero_cta_primary: "Join the Private Beta",
    hero_cta_secondary: "Discover Nephrix",
    hero_built_by: "Built by a dialysis patient, for dialysis patients.",

    // Trust badges
    trust_free: "Free during Private Beta",
    trust_patient: "Built by a dialysis patient",
    trust_privacy: "Privacy first",

    // Problem
    problem_title: "Dialysis care can feel overwhelming.",
    problem_body: "Living with dialysis means managing treatments, fluid limits, medications, laboratory results and daily symptoms. Nephrix brings these essential tools together in one clear and supportive experience.",

    // Features
    features_badge: "What Nephrix does",
    features_title: "Everything for your kidney care, in one place.",
    feature_tracking_title: "Dialysis Tracking",
    feature_tracking_desc: "Record treatment sessions, weight and blood pressure.",
    feature_fluid_title: "Fluid Intelligence",
    feature_fluid_desc: "Understand fluid accumulation between dialysis sessions.",
    feature_lab_title: "Lab Scan",
    feature_lab_desc: "Scan laboratory results and view them in a clearer format.",
    feature_copilot_title: "AI Copilot",
    feature_copilot_desc: "Receive educational support based on your recorded information.",
    feature_meds_title: "Medication Management",
    feature_meds_desc: "Keep treatments and medication schedules organized.",
    feature_timeline_title: "Health Timeline",
    feature_timeline_desc: "See important changes and trends over time.",

    // Founder Story
    story_badge: "Our story",
    story_title: "Created from real experience.",
    story_body: "Nephrix was created from real experience with kidney disease, transplantation and dialysis. The goal is simple: to make daily kidney care less overwhelming and help patients feel more informed and supported.",
    story_tagline: "Built with empathy. Designed for the kidney community.",

    // Medical Safety
    safety_title: "Medical Safety Notice",
    safety_body: "Nephrix provides educational and organizational support. It does not provide medical diagnosis and does not replace your nephrologist or healthcare team. In an emergency, contact your local emergency services.",

    // Footer
    footer_tagline: "A calm, focused companion for the kidney community.",
    footer_legal: "Legal",
    footer_help: "Help",
    footer_support: "Support",
    footer_contact: "Contact",
    privacy_policy: "Privacy Policy",
    terms_of_use: "Terms of Use",
    medical_disclaimer: "Medical Disclaimer",
    all_rights_reserved: "All rights reserved.",
  },

  ro: {
    nav_features: "Funcționalități",
    nav_story: "Poveste",
    nav_beta: "Beta",
    header_cta: "Înscrie-te în Beta",

    hero_badge: "Companion pentru sănătatea renală",
    hero_headline: "Călătoria ta cu dializa, mai ușor de înțeles.",
    hero_sub: "Nephrix ajută persoanele care fac dializă să urmărească tratamentele, fluidele, analizele de laborator și informațiile zilnice de sănătate — toate într-un singur loc.",
    hero_cta_primary: "Înscrie-te în Beta privat",
    hero_cta_secondary: "Descoperă Nephrix",
    hero_built_by: "Construit de un pacient dializat, pentru pacienți dializați.",

    trust_free: "Gratuit în Beta privat",
    trust_patient: "Construit de un pacient dializat",
    trust_privacy: "Confidențialitate prioritară",

    problem_title: "Îngrijirea în dializă poate fi copleșitoare.",
    problem_body: "A trăi cu dializă înseamnă gestionarea tratamentelor, a limitelor de lichide, a medicamentelor, a analizelor de laborator și a simptomelor zilnice. Nephrix aduce aceste unelte esențiale într-o experiență clară și de sprijin.",

    features_badge: "Ce face Nephrix",
    features_title: "Tot pentru îngrijirea ta renală, într-un singur loc.",
    feature_tracking_title: "Monitorizarea dializei",
    feature_tracking_desc: "Înregistrează ședințele de tratament, greutatea și tensiunea arterială.",
    feature_fluid_title: "Inteligență pentru fluide",
    feature_fluid_desc: "Înțelege acumularea de lichide între ședințele de dializă.",
    feature_lab_title: "Lab Scan",
    feature_lab_desc: "Scanează rezultatele de laborator și vezi-le într-un format mai clar.",
    feature_copilot_title: "AI Copilot",
    feature_copilot_desc: "Primești suport educațional pe baza informațiilor tale înregistrate.",
    feature_meds_title: "Managementul medicației",
    feature_meds_desc: "Menține tratamentele și programul de medicație organizate.",
    feature_timeline_title: "Cronologia sănătății",
    feature_timeline_desc: "Vezi schimbările importante și tendințele în timp.",

    story_badge: "Povestea noastră",
    story_title: "Creată din experiență reală.",
    story_body: "Nephrix a fost creată din experiență reală cu boala renală, transplant și dializă. Obiectivul este simplu: să facă îngrijirea zilnică renală mai puțin copleșitoare și să ajute pacienții să se simtă mai informați și susținuți.",
    story_tagline: "Construit cu empatie. Proiectat pentru comunitatea renală.",

    safety_title: "Notă de siguranță medicală",
    safety_body: "Nephrix oferă suport educațional și organizațional. Nu oferă diagnostic medical și nu înlocuiește nefrologul sau echipa ta medicală. În caz de urgență, contactează serviciile locale de urgență.",

    footer_tagline: "Un companion calm și concentrat pentru comunitatea renală.",
    footer_legal: "Legal",
    footer_help: "Ajutor",
    footer_support: "Suport",
    footer_contact: "Contact",
    privacy_policy: "Politica de Confidențialitate",
    terms_of_use: "Termeni de utilizare",
    medical_disclaimer: "Disclaimer medical",
    all_rights_reserved: "Toate drepturile rezervate.",
  },

  fr: {
    nav_features: "Fonctionnalités",
    nav_story: "Histoire",
    nav_beta: "Bêta",
    header_cta: "Rejoindre la Bêta",

    hero_badge: "Compagnon santé rénale",
    hero_headline: "Votre parcours en dialyse, plus facile à comprendre.",
    hero_sub: "Nephrix aide les personnes en dialyse à suivre leurs traitements, leurs fluides, leurs résultats d'analyses et leurs informations de santé quotidiennes — tout au même endroit.",
    hero_cta_primary: "Rejoindre la Bêta privée",
    hero_cta_secondary: "Découvrir Nephrix",
    hero_built_by: "Conçu par un patient dialysé, pour les patients dialysés.",

    trust_free: "Gratuit pendant la bêta privée",
    trust_patient: "Conçu par un patient dialysé",
    trust_privacy: "Confidentialité d'abord",

    problem_title: "La dialyse peut sembler écrasante.",
    problem_body: "Vivre avec la dialyse, c'est gérer les traitements, les limites de fluides, les médicaments, les résultats d'analyses et les symptômes quotidiens. Nephrix réunit ces outils essentiels dans une expérience claire et bienveillante.",

    features_badge: "Ce que fait Nephrix",
    features_title: "Tout pour vos soins rénaux, au même endroit.",
    feature_tracking_title: "Suivi de dialyse",
    feature_tracking_desc: "Enregistrez les séances, le poids et la tension artérielle.",
    feature_fluid_title: "Intelligence des fluides",
    feature_fluid_desc: "Comprenez l'accumulation de fluides entre les séances.",
    feature_lab_title: "Lab Scan",
    feature_lab_desc: "Scannez les résultats d'analyses dans un format plus clair.",
    feature_copilot_title: "AI Copilot",
    feature_copilot_desc: "Recevez un soutien éducatif basé sur vos informations enregistrées.",
    feature_meds_title: "Gestion des médicaments",
    feature_meds_desc: "Gardez traitements et prises de médicaments organisés.",
    feature_timeline_title: "Chronologie santé",
    feature_timeline_desc: "Voyez les changements et tendances importants dans le temps.",

    story_badge: "Notre histoire",
    story_title: "Née d'une expérience réelle.",
    story_body: "Nephrix est née d'une expérience réelle avec la maladie rénale, la transplantation et la dialyse. L'objectif est simple : rendre les soins rénaux quotidiens moins écrasants et aider les patients à se sentir mieux informés et soutenus.",
    story_tagline: "Conçu avec empathie. Pensé pour la communauté rénale.",

    safety_title: "Avertissement médical",
    safety_body: "Nephrix fournit un soutien éducatif et organisationnel. Il ne fournit pas de diagnostic médical et ne remplace pas votre néphrologue ni votre équipe soignante. En cas d'urgence, contactez les services d'urgence locaux.",

    footer_tagline: "Un compagnon calme et centré pour la communauté rénale.",
    footer_legal: "Légal",
    footer_help: "Aide",
    footer_support: "Support",
    footer_contact: "Contact",
    privacy_policy: "Politique de Confidentialité",
    terms_of_use: "Conditions d'utilisation",
    medical_disclaimer: "Avertissement médical",
    all_rights_reserved: "Tous droits réservés.",
  },
};

export const languages = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'ro', name: 'Română', flag: '🇷🇴' },
];
